import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  useFetchMarcasProduct,
  useUpdateMarcaProduct
} from '@/shared/actions/erp'
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';
import { MARCASPRODUCTO } from '@/shared/interfaces';
import { useUiConfirmModalStore } from '@/store/ui';
import { PermissionsEnum } from '@/auth/interfaces';
import { hasAllPermissions, hasPermission, useCheckPermissions, useTableFilter } from '@/shared';

const returnUrl = '/inventario/marca-productos';


export interface MarcasProductosPageInterface { }

const MarcasProductosPage: React.FC<MarcasProductosPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_marca_producto)

  const navigate = useNavigate();
  ///* global state
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );
  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex } = pagination;

  ///* fetch data
  const {
    data: marcasProductosPagingRes,
    isLoading,
    isRefetching,
  } = useFetchMarcasProduct({
    page: pageIndex + 1,
    nombre: searchTerm,
  });

  ///* mutations
  const updSate = useUpdateMarcaProduct({
    enableRedirect: false,
  });

  ///* handlers
  const onEdit = (original: MARCASPRODUCTO) => {
    navigate(`${returnUrl}/editar/${original.id_marca}`);
  };

  ///* columns
  const columns = useMemo<MRT_ColumnDef<MARCASPRODUCTO>[]>(
    () => [
      {
        accessorKey: 'numero_referencia',
        header: 'numero_referencia',
        size: 300,
      },
      {
        accessorKey: 'nombre',
        header: 'nombre',
        size: 300,
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return (
            <SwitchComponente
              estadoSwitch={row.original.estado}
              titulo={row.original.estado ? 'Activo' : 'Inactivo'}
              setEstadoSwitch={state => {
                if (!hasPermission(PermissionsEnum.api_change_marca_producto)) return;
                
                setConfirmDialog({
                  isOpen: true,
                  title: 'Cambiar Estado',
                  subtitle:
                    '¿Está seguro que desea cambiar el estado de esta marca ?',
                  onConfirm: () => {
                    setConfirmDialogIsOpen(false);
                    updSate.mutate({
                      id: row.original.id_marca!,
                      data: { estado: !!state } as any,
                    });
                  },
                });
              }}
            />
          );
        },
      }
    ],
    []
  );

  return (
    <SingleTableBoxScene title="Marcas producto" urlRedirect={`${returnUrl}/crear`}/*  showCreateBtn={hasPermission(PermissionsEnum.api_add_marca_producto)} */>
      <CustomSearch onChange={onChangeFilter} value={globalFilter} text="marcas producto" />

      <GeneralTable<MARCASPRODUCTO>
        columns={columns}
        data={marcasProductosPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={marcasProductosPagingRes?.data?.count}
        // // actions
        enableColumnActions={hasAllPermissions([
          PermissionsEnum.api_change_marca_producto,
        ])}
        // crud
        onEdit={onEdit}
        canEdit={hasAllPermissions([
          PermissionsEnum.api_change_marca_producto,
        ])}
        canDelete={false}
      />
    </SingleTableBoxScene>
  );
};

export default MarcasProductosPage;

